import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import useNotes from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import { getIntl } from '../../../../../utils/intl';
import EmailListConfiguration from '../../../../shared/EmailListConfiguration';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';

const intl = getIntl('sendProfileNoteScreen', {
    sendNote: 'Share Note',
});

export type SendNoteScreenOwnProps = {};

export type SendNoteScreenProps = SendNoteScreenOwnProps & { route: RouteProp<ProfilesTabParamList, 'send-note'> };

const SendNoteScreen: React.FC<SendNoteScreenProps> = (props) => {
    const goBack = useGoBack();
    const [emails, setEmails] = React.useState<string[]>([]);
    const { sendNoteEmail, isSendingNoteEmail } = useNotes({
        noteId: props.route.params.noteId,
        onSendNoteEmailSuccess: () => {
            goBack();
        },
    });

    return (
        <ActionButtonLayout
            actions={[
                {
                    title: intl('sendNote'),
                    onPress: () => {
                        sendNoteEmail({
                            noteId: props.route.params.noteId,
                            emails,
                        });
                    },
                    isDisabled: !emails.length || isSendingNoteEmail,
                    testID: 'send-note-button',
                    icon: 'Send',
                },
            ]}
        >
            <MainContentContainer>
                <EmailListConfiguration
                    value={emails}
                    onChange={setEmails}
                    medicalProfileId={props.route.params.profileId}
                />
            </MainContentContainer>
        </ActionButtonLayout>
    );
};

export default React.memo(SendNoteScreen);
